import React from 'react';
import siteLogo from '../../assets/Famphy-on-call-logo-website.png';
import { Link } from 'react-router-dom';
export default function logo() {
  return (
    <div className="sitelogo-box">
        <Link className="nav-link" to="/"><img src={siteLogo} alt="Famphy On Call Logo" className="sitelogo" /> </Link>     
    </div>
  );
}
